export default "__VITE_ASSET__3UtITdue__"